import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, catchError, map, throwError } from 'rxjs';

import { RequestOptions } from './interfaces/request.interface';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HttpRequestService {
  protected readonly http = inject(HttpClient);
  protected readonly api = environment.API_URL;
  protected readonly router = inject(Router);

  public get<T>(endpoint: string, options?: RequestOptions): Observable<T> {
    return this.http.get<T>(`${this.api}${endpoint}`, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => res.body as T),
      catchError((error: HttpErrorResponse) => throwError(() => this.resolveError(error)))
    );
  }

  public postUser<T>(endpoint: string, body: unknown, options?: RequestOptions): Observable<T> {
    return this.http.post<T>(`${this.api}${endpoint}`, body, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => res.body as T),
      catchError((error: HttpErrorResponse) => throwError(() => this.resolveError(error)))
    );
  }

  public post<T>(endpoint: string, body: unknown, options?: RequestOptions): Observable<T> {
    return this.http.post<T>(`${this.api}${endpoint}`, body, {
      ...options,
      observe: 'response',
      responseType: 'json'
    }).pipe(
      map((res: HttpResponse<T>) => res.body as T),
      catchError((error: HttpErrorResponse) => throwError(() => this.resolveError(error)))
    );
  }

  public logout(): void {
    localStorage.clear();
    this.router.navigate(['/auth/iniciar-sesion']);
  }

  private resolveError(error: HttpErrorResponse): string {
    if (error.status === 401 && !error.url?.includes('/auth/')) {
      this.logout();
    }

    return error?.error?.message ?? error?.error?.detail ?? 'Ha ocurrido un error en el servidor.';
  }
}
